import { createFileRoute } from "@tanstack/react-router";
import { MacroCatalog } from "@/components/views/macro/MacroCatalog";

export const Route = createFileRoute("/catalog/")({
  component: MacroCatalog,
});
